// extracted by mini-css-extract-plugin
export default {"textarea":"ta1XEH","standard":"lOfjjQ","errored":"MDVYh7"};